/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FailureTypeVm,
    FailureTypeVmFromJSON,
    FailureTypeVmFromJSONTyped,
    FailureTypeVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface FailureTypeVmPaginatedSearchResponse
 */
export interface FailureTypeVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<FailureTypeVm>}
     * @memberof FailureTypeVmPaginatedSearchResponse
     */
    items?: Array<FailureTypeVm> | null;
    /**
     * 
     * @type {number}
     * @memberof FailureTypeVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureTypeVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureTypeVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureTypeVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureTypeVmPaginatedSearchResponse
     */
    size?: number;
}

export function FailureTypeVmPaginatedSearchResponseFromJSON(json: any): FailureTypeVmPaginatedSearchResponse {
    return FailureTypeVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function FailureTypeVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureTypeVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(FailureTypeVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function FailureTypeVmPaginatedSearchResponseToJSON(value?: FailureTypeVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(FailureTypeVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


